import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { InjectedPagesProps, withPages } from 'src/_context/Pages';
import responsive from '../constants/responsive';
import spacing from '../constants/spacing';
export type PageScrollContainerProps = {

};

const styles = {
  content: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    overflow: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    pointerEvents: 'initial',
    [responsive.Mobile]: {
      width: spacing.MainRightSideWidth.Mobile,
      left: spacing.PositionMainRightSideWidth.Mobile,
      zIndex: 10,
      backgroundColor: '#FFF',
      transition: 'transform 0.4s ease',
      '*[data-position="pages"] &, *[data-position="detail"] &': {
        transform: 'translate3d(-100vw, 0, 0)'
      },
    },
    [responsive.Tablet]: {
      width: '100%',
      left: 0,
      paddingTop: spacing.Gutter.Tablet,
      paddingBottom: spacing.Gutter.Tablet,
      paddingRight: spacing.Gutter.Tablet / 2,
      paddingLeft: spacing.PositionMainRightSideWidth.Tablet
    },
    [responsive.Laptop]: {
      width: '100%',
      left: 0,
      paddingTop: spacing.Gutter.Laptop,
      paddingBottom: spacing.Gutter.Laptop,
      paddingRight: spacing.Gutter.Laptop / 2,
      paddingLeft: spacing.PositionMainRightSideWidth.Laptop
    },
    [responsive.Desktop]: {
      width: '100%',
      left: 0,
      paddingTop: spacing.Gutter.Desktop,
      paddingBottom: spacing.Gutter.Desktop,
      paddingRight: spacing.Gutter.Desktop / 2,
      paddingLeft: spacing.PositionMainRightSideWidth.Desktop
    }
  }
};

type Props =
  {
    types: string[];
  } &
  PageScrollContainerProps &
  InjectedPagesProps &
  StyledComponentProps<keyof typeof styles>;

class PageScrollContainer extends React.Component<Props> {
  private readonly container = React.createRef<HTMLDivElement>();
  componentDidMount() {
    if (this.container.current) {
      this.container.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { pagesCtx: { activeId: prevActiveId } } = prevProps;
    const { pagesCtx: { activeId, page }, types } = this.props;

    if (activeId !== prevActiveId && this.container.current && (!page || types.indexOf(page.type) >= 0)) {
      this.container.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }

  public render() {
    const { classes } = this.props;
    return (
      <div className={classes!.content} ref={this.container}>
        {this.props.children}
      </div>
    );
  }

}

export default withPages(withStyles(styles)(PageScrollContainer));



// WEBPACK FOOTER //
// ./src/components/PageScrollContainer.tsx